import { getUuidMin } from '@front10/helpers/dist/uuid';
import * as logger from 'loglevel';
import axiosWrapper from '../../helpers/axiosWrapper';
import { NO_DURATION_DEFINED } from '../../helpers/axiosWrapper/cache';
import { getDateRangeAsDates } from '../../helpers/localization/localizationUtils';
import { getCorrectImage } from './package';
import transformRequestGroupRoutes from './transformRequest/transformSmartFilter';

/**
 * Makes sure the fares response is complain with a basic schema
 * @param {*} fares
 */
const validateFaresResponse = (fares) => {
  const validation = { isValid: true, message: '' };
  if (!fares || !Array.isArray(fares)) {
    validation.isValid = false;
    return {
      isValid: false,
      data: fares,
      message: 'INTEGRATION__FARES: Fares must be an Array'
    };
  }
  if (fares.length > 0) {
    const fareItem = fares[0];
    if (!fareItem.car || !fareItem.journey || !fareItem.priceSpecification) {
      return {
        isValid: false,
        data: fareItem,
        message:
          'INTEGRATION__FARES: FareItem SCHEMA is invalid, please check Fares API documentation.'
      };
    }
  }
  return validation;
};

const transformData = (routesRawData) => {
  const fares = routesRawData
    .map(
      ({
        car: carRaw,
        journey: journeyRaw,
        priceSpecification: priceSpecificationRaw,
        searchDate
      }) => {
        // Workaround for Safari and IE
        if (searchDate && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d+[+|-]\d{4}/.test(searchDate)) {
          searchDate = `${searchDate.substring(0, searchDate.length - 2)}:${searchDate.substring(
            searchDate.length - 2
          )}`;
        }

        let fields = journeyRaw.additionalInfo?.fields;
        const originDestination = Boolean(fields)
          ? fields.filter((field) => field.name === 'origin' || field.name === 'destination')
          : [];
        //PENDING: Las prioridades de las imágenes.
        const newFare = {
          hotelId: carRaw.id,
          // hotelGroup: hotelRaw.group,
          hotelName: carRaw.brand,
          // hotelRoomCount: hotelRaw.roomCount,
          // rating: hotelRaw?.rating?.value,
          ...journeyRaw,
          ...carRaw,
          origin: journeyRaw.outboundFlight.departureAirportIataCode,
          aditionalOrigin: originDestination.length > 0 ? originDestination[0].value : '',
          originCity: journeyRaw.outboundFlight.origin?.city?.name,
          destination: journeyRaw.outboundFlight.arrivalAirportIataCode,
          aditionalDestination: originDestination.length > 1 ? originDestination[1].value : '',
          destinationCity: journeyRaw.outboundFlight.destination?.city?.name,
          farenetTravelClass: journeyRaw.outboundFlight.fareClass,
          ...priceSpecificationRaw,
          // journeyType: journeyTypeMap[flightType],
          searchDate,
          destinationImage: getCorrectImage(carRaw, journeyRaw),
          airlineLogoSm: carRaw.provider?.logo
        };

        newFare.index = getUuidMin(
          `${newFare.hotelId}
            ${newFare.hotelName}
            ${newFare.hotelRoomCount}
            ${newFare.rating}
            ${newFare.origin}
            ${newFare.destination}
            ${newFare.farenetTravelClass}
            ${searchDate}`
        );

        delete newFare.outboundFlight;
        return newFare;
      }
    )
    .reduce((a, b) => a.concat(b), []); // arr.flat()
  return fares;
};

/**
 * Retrieve fares from the GroupRoutes Endpoint
 * @param {*} filter
 * @param {*} integrationSettings
 */
const getFares = (filter, integrationSettings, meta, pageContext) => {
  return new Promise((resolve, reject) => {
    if (!integrationSettings) {
      const MESSAGE = `INTEGRATION__FARES: **integrationSettings** not specified.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }
    const { v1GlobetrotterCarPackagesSmart: faresApiSettings } = integrationSettings;
    const { cache = false, cacheDuration = NO_DURATION_DEFINED } = faresApiSettings;
    const filterCopy = { ...filter };

    if (
      !faresApiSettings ||
      !faresApiSettings.method ||
      !faresApiSettings.endPoint ||
      !faresApiSettings.headers
    ) {
      const MESSAGE = `INTEGRATION__FARES: **integrationSettings.v1GlobetrotterCarPackagesSmart** configuration issues.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }

    filterCopy.departure = getDateRangeAsDates(
      filterCopy.departure,
      'YYYY-MM-DD',
      'INTEGRATION__FARES'
    );
    if (filterCopy.return) {
      filterCopy.return = getDateRangeAsDates(
        filterCopy.return,
        'YYYY-MM-DD',
        'INTEGRATION__FARES'
      );
    }

    //INFO: Doing an override to be able to use the pagination of the other modules on this endpoint
    filterCopy.packagesLimit = filterCopy.routesLimit || filterCopy.packagesLimit;

    axiosWrapper(
      {
        method: faresApiSettings.method,
        url: `${faresApiSettings.endPoint}`,
        headers: { ...faresApiSettings.headers },
        data: transformRequestGroupRoutes(filterCopy)
      },
      {
        resource: 'INTEGRATION__SMART__FARES__SEARCH',
        meta,
        integrationSettings,
        pageContext,
        cache,
        cacheDuration
      }
    )
      .then((response) => {
        const validation = validateFaresResponse(response.data);
        if (validation.isValid) {
          logger.info('INTEGRATION__FARES: Successful request', response.data);
          const fares = transformData(response.data);
          resolve(fares);
        } else {
          logger.error(validation.message, validation.data);
          reject(response.data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export { getFares, transformData };
